import LanguageIcon from "@mui/icons-material/Language";
import cx from "classnames";
import UpDownArrows from "src/components/general/UpDownArrows/UpDownArrows";
import { MAX_TZ, MIN_TZ, REFRESH_EVERY } from "./TimeZoneSelector.constants";
import { useIntervalRerender, useTimezone } from "./TimeZoneSelector.hooks";

const TimeZoneSelector = ({ className }: { className?: string }) => {
  const { tz, setTZ, formattedTime, tzStr } = useTimezone();

  // Rerender to update the rendered value
  useIntervalRerender(REFRESH_EVERY);

  return (
    <div
      className={cx(
        "flex items-center gap-2 text-xs text-text-secondary",
        className
      )}
      data-test-id="tz-select"
    >
      <LanguageIcon fontSize="small" color="disabled" />
      <span>{formattedTime}</span>
      <div className="flex items-center gap-1 select-none ml-3">
        <UpDownArrows
          value={tz}
          min={MIN_TZ}
          max={MAX_TZ}
          onUpClick={() => setTZ(tz + 1)}
          onDownClick={() => setTZ(tz - 1)}
          slotProps={{
            up: { "data-test-id": "tz-up" },
            down: { "data-test-id": "tz-down" },
          }}
        />
        <span data-test-id="tz-value">UTC{tzStr && ` ${tzStr}`}</span>
      </div>
    </div>
  );
};

export default TimeZoneSelector;
